module.exports = __webpack_public_path__ + "static/media/traffic-yes.54a8e559.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-yes.svg
// module id = 427
// module chunks = 0